import { MeetingServiceRequestStatus } from '../../generated/graphql';
export var getTagColor = function (status) {
    switch (status) {
        case MeetingServiceRequestStatus.Blocked:
        case MeetingServiceRequestStatus.NeedsApproval:
            return 'warning';
        case MeetingServiceRequestStatus.InProgress:
            return 'processing';
        case MeetingServiceRequestStatus.Done:
            return 'success';
        case MeetingServiceRequestStatus.Cancelled:
        case MeetingServiceRequestStatus.Rejected:
            return 'error';
        default:
            return 'default';
    }
};
export var getTagLabel = function (status, t) {
    switch (status) {
        case MeetingServiceRequestStatus.Todo:
            return t('eventDetails.space.meeting_service_status.todo');
        case MeetingServiceRequestStatus.InProgress:
            return t('eventDetails.space.meeting_service_status.in_progress');
        case MeetingServiceRequestStatus.Blocked:
            return t('eventDetails.space.meeting_service_status.blocked');
        case MeetingServiceRequestStatus.Done:
            return t('eventDetails.space.meeting_service_status.done');
        case MeetingServiceRequestStatus.Cancelled:
            return t('eventDetails.space.meeting_service_status.cancelled');
        case MeetingServiceRequestStatus.Rejected:
            return t('eventDetails.space.meeting_service_status.rejected');
        case MeetingServiceRequestStatus.NeedsApproval:
            return t('eventDetails.space.meeting_service_status.needs_approval');
        default:
            return status;
    }
};
